import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import siteReducer from './siteReducer'
import activationReducer from './activationReducer'
import configReducer from './configReducer'

export default combineReducers({ siteReducer, routerReducer, configReducer, activationReducer })



// WEBPACK FOOTER //
// ./src/reducers/index.js